
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.802 33.081a3.242 3.242 0 013.238 3.24 3.243 3.243 0 01-3.238 3.239 3.243 3.243 0 01-3.241-3.238 3.244 3.244 0 013.24-3.24zm16.198 0a3.242 3.242 0 013.238 3.24A3.241 3.241 0 0132 39.56a3.242 3.242 0 01-3.24-3.238 3.244 3.244 0 013.24-3.24zM15.802 35.24a1.08 1.08 0 100 2.159 1.08 1.08 0 000-2.159zm16.198 0c-.596 0-1.082.483-1.082 1.08a1.082 1.082 0 002.161 0A1.08 1.08 0 0032 35.24zM11.48 26.597a2.16 2.16 0 002.16 2.16v.002h23.758c.596 0 1.082.483 1.082 1.081 0 .597-.486 1.08-1.082 1.08H13.64a4.325 4.325 0 01-4.32-4.32 4.328 4.328 0 012.989-4.11L8.476 7.16H5V5h5.166l4.317 17.28h21.922l.999-11.969-.005-.991h2.161v1.082l-1.168 14.037H13.64c-1.19 0-2.159.969-2.159 2.158zm20.083-11.662c.596 0 1.082.483 1.082 1.081 0 .597-.486 1.08-1.082 1.08H18.175a1.08 1.08 0 010-2.161h13.389zm0-5.184c.596 0 1.082.483 1.082 1.081 0 .597-.486 1.08-1.082 1.08H18.175a1.08 1.08 0 010-2.161h13.389z","fill":"currentColor","fill-rule":"nonzero"}})])
          )
        }
      }
    